import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 40,
  },
  item: {
    marginBottom: theme.spacing(2),
  },
  corpoFormulario: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  labelSemDados: {
    padding: theme.spacing(4),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
  inputForm: {
    marginTop: theme.spacing(1.5),
  },
  groupFiliacao: {
    marginBottom: theme.spacing(2),
  },
  botaoAddFiliacao: {
    marginLeft: theme.spacing(1),
  },
  dataNascimento: {
    width: '100%',
    height: '56px',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.divider}`,
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    outline: 'none',
    boxSizing: 'border-box',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: theme.palette.primary.main,
      borderWidth: '2px',
      padding: '15px', // Compensa a espessura da borda de 2px
    },
    '&:hover': {
      borderColor: theme.palette.text.primary,
    },
  },
}))
